// extracted by mini-css-extract-plugin
export var statItem = "_ka-1";
export var statsRow = "_ka-0";